<template>
  <el-card shadow="never" class="mg-searc-form">
    <el-form ref="form" :model="form" v-bind="$attrs" v-on="$listeners" @keydown.enter.native.prevent="handleSearch">
      <el-row type="flex">
        <template v-for="{ attrs, on, label, labelWidth, required, rules, error, ...item } in formItemList">
          <el-col
            v-if="!item.hidden"
            :key="item.type === 'FormItemDropdown' ? command : item.model"
            :span="item.span || span"
          >
            <!-- dropdown 组件特殊处理 -->
            <el-form-item
              v-if="item.type === 'FormItemDropdown'"
              v-bind="{ label, labelWidth, required, error }"
              :prop="command"
              :rules="rules ? rules[command] || rules : null"
            >
              <template #label>
                <FormItemDropdown :options="item.options" v-model="command" />
              </template>
              <el-input clearable v-model="form[command]" :placeholder="item.placeholder" v-bind="attrs" v-on="on" />
            </el-form-item>
            <template v-else-if="item.type === 'FormItemDropdownNew'">
              <el-form-item v-bind="{ label, labelWidth, required, error }" :prop="item.model">
                <template #label>
                  <div>
                    <FormItemDropdown
                      v-for="dda in item.dropdownAttrs"
                      :key="dda.model"
                      :options="dda.options"
                      v-model="form[dda.model]"
                      :labelSize="20"
                    />
                  </div>
                </template>
                <el-input
                  clearable
                  v-model="form[item.model]"
                  :placeholder="item.placeholder"
                  v-bind="attrs"
                  v-on="on"
                />
              </el-form-item>
            </template>
            <!--树形结构-->
            <template v-else-if="item.type === 'FormItemNewTree'">
              <el-form-item v-bind="{ label, labelWidth, required, error }" :prop="item.model">
                <mg-select-tree
                  :ref="item.model"
                  :placeholder="item.placeholder"
                  v-bind="attrs"
                  v-on="on"
                  v-model="form[item.model]"
                />
              </el-form-item>
            </template>
            <!-- 其他通用组件封装 -->
            <el-form-item v-else v-bind="{ prop: item.model, label, labelWidth, required, rules, error }">
              <component
                :ref="item.model"
                :is="item.type"
                :placeholder="item.placeholder"
                v-bind="attrs"
                v-on="on"
                v-model="form[item.model]"
                :item="item"
              />
            </el-form-item>
          </el-col>
        </template>

        <el-col class="button_box" :span="4">
          <el-form-item class="button_form_item">
            <el-button class="mg-query-btn" type="primary" @click="handleSearch">{{ $MGUI.i18n.t('查询') }}</el-button>
            <el-button class="mg-reset-btn" @click="handleReset">{{ $MGUI.i18n.t('重置') }}</el-button>
            <slot name="button-right" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
  import FormItemDropdown from '../components/form-item-dropdown'
  import FormItemSelect from '../components/form-item-select'
  import FormItemSelectTree from '../components/form-item-select-tree'
  import FormItemDate from '../components/form-item-date'
  import FormItemInput from '../components/form-item-input'
  import FormItemAutocomplete from '../components/form-item-autocomplete'
  import FormItemSwitch from '../components/form-item-switch'
  export default {
    name: 'MgSearchForm',
    props: {
      span: {
        type: Number,
        default: 12,
      },
      // 表单基本配置数据
      formItemList: {
        type: Array,
        default: () => [],
      },
      beforeSearch: Function,
    },
    components: {
      FormItemDropdown,
      FormItemSelect,
      FormItemSelectTree,
      FormItemDate,
      FormItemInput,
      FormItemAutocomplete,
      FormItemSwitch,
    },
    data() {
      return {
        command: '',
        form: {},
        formMap: {},
        visible: false,
        searchTags: [],
      }
    },
    watch: {
      command(_, oldVal) {
        if (oldVal) {
          this.form[oldVal] = null
        }
      },
    },

    activated() {
      console.log('TIPS search-from from activated')
    },

    mounted() {
      this.initialForm()
    },
    methods: {
      initialForm() {
        // console.log('TIPS search-from initialForm:', this.formItemList)
        this.formItemList.forEach((item) => {
          if (item.type === 'FormItemDropdown') {
            // dropdown label 当 command 有值时，重置操作需要重置该属性下的值
            if (this.command) {
              this.$set(
                this.form,
                this.command,
                ['', null, undefined].includes(item.initialValue) ? null : item.initialValue
              )
            }
            this.command = item.model
          }
          if (item.type === 'FormItemDate') {
            if (item.attrs.type.endsWith('range')) {
              this.formMap[item.model] = {
                begin: item.attrs.begin,
                end: item.attrs.end,
              }
            }
          }
          if (item.type === 'FormItemDropdownNew') {
            item.dropdownAttrs.forEach((i) => {
              this.$set(this.form, i.model, ['', null, undefined].includes(i.initialValue) ? null : i.initialValue)
            })
            console.log(this.form, item, '----')
          }
          this.$set(this.form, item.model, ['', null, undefined].includes(item.initialValue) ? null : item.initialValue)
        })
      },
      setFormItemModel(model, value) {
        this.form[model] = value
      },
      handleRemoveTag(tag) {
        this.$refs.advancedSearch.setFormValue(tag.model, null)
        this.$refs.advancedSearch.handleSearch()
      },
      handleClearAllTag() {
        this.searchTags = []
        this.$refs.advancedSearch.clearAll()
        this.handleSearch()
      },
      handleFormItemChange(formItemList) {
        this.$emit('update:formItemList', formItemList)
        formItemList.forEach((item) => {
          if (item.hidden) {
            this.setFormItemModel(item.model, null)
          }
        })
      },
      handleSubmit(data) {
        this.searchTags = []
        this.$emit('getSearchFormData', data)
      },
      getFormItemOptionsByModel(model) {
        return this.$refs[model]?.[0].options
      },
      setFormItemOptionsByModel(model, data) {
        if (this.$refs[model]) this.$refs[model][0].loadOptions = data
      },
      // 获取各搜索项显示的值
      getDisplayValueByModel(model) {
        return this.$refs[model]?.[0]?.getDisplayValue()
      },
      handleSearch() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const params = { ...this.form }
            Object.keys(this.formMap).forEach((key) => {
              params[this.formMap[key].begin] = this.form[key]?.[0]
              params[this.formMap[key].end] = this.form[key]?.[1]
              delete params[key]
            })
            console.log('this.beforeSearch', this.beforeSearch)
            if (this.beforeSearch)
              this.beforeSearch(params, () => {
                this.handleSubmit(params)
              })
            else this.handleSubmit(params)
          }
        })
      },
      handleReset() {
        this.initialForm()
        this.handleSearch()
      },
    },
  }
</script>

<style scoped lang="scss">
  .mg-searc-form {
    overflow: unset !important;
    border: none;
    --mg-search-form-label-offset-y: 3px;
  }

  ::v-deep {
    .expand-toggle-btn {
      margin-left: 8px;
      margin-right: -8px;
      height: 40px !important;
      padding: 0 !important;
      box-sizing: border-box;
    }
    .expand-toggle-btn .expand-toggle-content {
      display: inline-flex;
      align-items: center;
      gap: 0;
      white-space: nowrap;
    }
    .expand-toggle-btn .expand-toggle-text {
      line-height: 1;
    }
    .expand-toggle-btn .expand-toggle-icon {
      width: 40px;
      height: 40px;
      margin-left: -8px;
      display: inline-block;
      flex-shrink: 0;
    }
    // 统一 formItemList 的字体：label、value、placeholder 均为 18px
    .el-form-item__label {
      font-family: PingFangSC, PingFang SC !important;
      font-weight: 400 !important;
      font-size: 18px !important;
      color: #000000 !important;
      font-style: normal;
      height: 40px !important;
      line-height: 40px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      transform: translateY(var(--mg-search-form-label-offset-y, 0px));
    }
    .el-form-item__content {
      line-height: 40px;
    }
    .el-input__inner,
    .el-select .el-input__inner,
    .el-select__tags-text,
    .el-cascader .el-input__inner {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px !important;
      font-style: normal;
      height: 40px;
      line-height: 40px;
    }
    .el-date-editor .el-range-input,
    .el-date-editor .el-range-separator {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px !important;
      font-style: normal;
    }
    .el-input__inner::placeholder,
    .el-input__inner::-webkit-input-placeholder,
    .el-input__inner::-moz-placeholder,
    .el-input__inner:-ms-input-placeholder,
    .el-select .el-input__inner::placeholder,
    .el-cascader .el-input__inner::placeholder {
      font-family: PingFangSC, PingFang SC;
      // 与输入值字重保持一致，避免视觉上“placeholder 更小”
      font-weight: 400;
      font-size: 18px !important;
      line-height: 40px;
      color: #333333 !important;
      font-style: normal;
      opacity: 1 !important;
    }
    .el-tag.el-tag--info {
      color: rgba(#252a3d, 0.75);
      background-color: #ffffff;
    }
    .el-card__body {
      padding: 12px;
    }
    .input_number {
      width: 78px;
      .el-input--mini {
        width: 81px;
      }
    }
    .monthrange {
      display: flex;
      flex-wrap: nowrap;
    }
    .month_range {
      width: 113px;
      .el-input--mini {
        width: 81px;
      }
    }
    .el-row {
      display: flex;
      flex-wrap: wrap;
      column-gap: 52px;
    }
    // 两列布局（span=12）时，保证两项之间最小间距 52px
    .el-col-12 {
      flex: 0 0 calc((100% - 52px) / 2);
      max-width: calc((100% - 52px) / 2);
    }
    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0 15px;
      text-align: center;
      i {
        transform: rotate(90deg);
      }
    }
    .el-input-group__append,
    .el-input-group__prepend {
      font-size: 14px;
      font-weight: bold;
      color: #ea2838;
      background-color: #ffffff;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 8px;
    }
  }

  .button_box {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  ::v-deep .button_form_item {
    margin-bottom: 0;
  }

  ::v-deep .button_form_item.el-form-item--small.el-form-item {
    margin-bottom: 22px;
  }

  ::v-deep .button_form_item.el-form-item--mini.el-form-item {
    margin-bottom: 8px;
  }

  ::v-deep .button_form_item .el-form-item__content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
    line-height: 40px;
  }

  .button_box {
    ::v-deep(.el-button) {
      flex-shrink: 0;
      min-width: 60px;
    }
    ::v-deep(.el-button + .el-button) {
      margin-left: 8px;
    }
  }
</style>
